export const getBrandingSettingsFetching = state => state?.brandingManager?.fetching || false;

export const getBrandingSettings = state => {
    return state?.brandingManager?.data || false;
};
